import { appState } from "@/app/appState";
import { ChatObjectType, chatState } from "@/app/chatState";
import { EntryList } from "@/components/UI/tools";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface ChatEntryListProps<T> {
    items: T[];
    object_type: ChatObjectType;
    subtitle?: string;
    intent?: string;
    extractDisplayValue: (item: T) => string;
    extractId: (item: T) => number;
    deleteFunction: (ids: number[]) => Promise<any>;
    routePath: string;
    containerClassName?: string;
    containerStyle?: React.CSSProperties;
    debugMessage?: string;
    highlightedId?: number | null;
}


export const ChatEntryList = <T,>({
    items,
    object_type,
    subtitle,
    intent,
    extractDisplayValue,
    extractId,
    deleteFunction,
    routePath,
    containerClassName = "h-10 w-full",
    containerStyle,
    debugMessage,
    highlightedId
}: ChatEntryListProps<T>) => {
    const [loading, _] = useState(false);
    const navigate = useNavigate();
    const [ids, setIds] = useState<number[]>([]);



    useEffect(() => {
        if (debugMessage) {
            console.log(debugMessage);
        }
    }, [debugMessage]);

    const setId = (id: number | undefined) => {
        if (id && id > 0) {
            chatState.openObject({ type: object_type, id: id });
        }
    };

    const trimmedIntent = intent?.trim();

    return (
        <div className={containerClassName + " !max-h-[300px] !overflow-y-auto"} style={containerStyle}>
            <EntryList
                name={`${object_type} query`}
                subtitle={trimmedIntent || subtitle}
                idParams={{ singular: { set: setId }, plural: { get: ids, set: setIds } }}
                loading={loading}
                deleting={false}
                readonly={true}

                items={items?.map((item) => ({
                    id: extractId(item),
                    val: extractDisplayValue(item),
                    highlighted: highlightedId === extractId(item),
                    lock: false
                }))}
            />
        </div>
    );
};
